import { isCompareGraphOverlay } from '@ipfabric/utils';
import type { GraphState } from 'components/Graph/GraphState';

export const selectComparingSameSnapshots: (s: GraphState) => boolean = (s) =>
  isCompareGraphOverlay(s.overlay) &&
  s.snapshotId === s.overlay.snapshotToCompare;
